'use client'

import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export default function Redirect({ url }: { url: string }) {
	const navigate = useNavigate()

	useEffect(() => {
		navigate(url)
	}, [navigate, url])

	return <></>
}
